import { GridSize } from "@mui/material"
import { ui, temp, api } from "../../../interfaces/interfaces"
import AddressUtils from "@utils/address"
import { Scope } from "@utils/address/model"
import { AddressFields } from "@utils/BasicTypes"
import { handleBasicChange } from "@utils/general"
import { FormHandlerObject } from "@utils/general/interfaces"

export type A11yProps = {
    (name: string, prefix: Scope, form?: FormHandlerObject): {
        id: string
        name: string
        fullWidth: boolean
        autoComplete: string
        "aria-controls": string
        onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
        onBlur: (event: React.FocusEvent<HTMLInputElement>) => void
    }
}

export const a11yProps: A11yProps = (name, prefix, form) => {
    if (form) {
        if (prefix && name && name !== "Country" && !form.list.includes(`${prefix}${name}`))
            form.list.push(`${prefix}${name}`)
        if (!form.list.includes(`${prefix}PostCode`)) form.list.push(`${prefix}PostCode`)
    }
    return {
        id: `input-${name.toLowerCase()}`,
        name,
        fullWidth: true,
        autoComplete: 'none',
        "aria-controls": `action-input-${name.toLowerCase()}`,
        onChange: name === "Postcode" ? (event) => AddressUtils.handlePostCodeChange({ event, prefix, ui, temp }) : (event) => handleBasicChange(event, prefix),
        onBlur: () => AddressUtils.convertAddressFormFieldsToAddress({ scope: prefix, ui })
    };
}

export type MemoizedInputProps = {
    parent: string
    prefix: Scope
    inputName: AddressFields
    xs: GridSize
    sm: GridSize
    disabled: boolean
    form?: FormHandlerObject
}

export const handleKeyPress = (ev: { key: string; preventDefault: () => void }, valid: boolean, prefix: Scope) => {
    if (ev.key === "Enter") {
        ev.preventDefault();
        if (valid) AddressUtils.searchAddresses({ temp, ui, api, prefix });
    }
};